module.exports = new Promise(function(resolve) {
    if (typeof window["appointmentApp"] !== "undefined") return resolve(window["appointmentApp"]);
    var resolved = false;
    function done(container) {
      if (resolved) return;
      resolved = true;
      resolve(container);
    }
    var timer = setTimeout(function() {
      console.warn("[MF] Remote appointmentApp at http://localhost:3012/remoteEntry.js timed out after 3000ms");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    }, 3000);
    var script = document.createElement("script");
    script.src = "http://localhost:3012/remoteEntry.js";
    script.async = true;
    script.onload = function() {
      clearTimeout(timer);
      if (window["appointmentApp"]) {
        done(window["appointmentApp"]);
      } else {
        console.warn("[MF] Remote appointmentApp loaded but container not found");
        done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
      }
    };
    script.onerror = function() {
      clearTimeout(timer);
      console.warn("[MF] Remote appointmentApp at http://localhost:3012/remoteEntry.js unreachable");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    };
    document.head.appendChild(script);
  });